import { API, fetcher } from "@/shared/core-configs";

export const productApi = {
  getLocalProductReport: async (id: string) => {
    const response = await fetcher.get(
      `${API.GESLUB_SERVICE}/external-product/${id}/report`,
      {
        responseType: "blob",
      },
    );
    if (!response) {
      throw new Error("Error al obtener el reporte del producto local");
    }
    return response.data;
  },
  exportExternalProductsExcel: async (params: string) => {
    const response = await fetcher.get(
      `${API.GESLUB_SERVICE}/external-product/export-excel?${params}`,
      { responseType: "blob" },
    );
    if (!response) {
      throw new Error("Error al exportar productos locales a Excel");
    }
    return response.data;
  },
  uploadImageLocalProduct: async (id: string, file: File) => {
    const formData = new FormData();
    formData.append("image", file);

    const response = await fetcher.post(
      `${API.GESLUB_SERVICE}/external-product/${id}/image`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    if (!response) {
      throw new Error("Error al subir la imagen del producto local");
    }
    return response.data;
  },
};
